import type {
  OrderGetResponseType,
  OrderShippingRequestItemType,
} from "@sellar-io/api-v2/types";
import { createContext } from "react";

export const OrderCreateShippingContext = createContext<
  | {
      items: (OrderGetResponseType["OrderItems"][number] & {
        itemId: number;
      })[];
      setItems: (
        items: (OrderGetResponseType["OrderItems"][number] & {
          itemId: number;
        })[],
      ) => void;
      boxes: OrderShippingRequestItemType[];
      setBoxes: (boxes: OrderShippingRequestItemType[]) => void;
    }
  | undefined
>(undefined);
